import ProductSearchMixin from '../../mixins/ProductSearchMixin';
import template from './ProductSearchComponent.html';

export default {
  template,

  name: 'ProductSearchComponent',

  mixins: [ProductSearchMixin],

  data() {
    return {};
  },

  methods: {
    editProduct(productId) {
      window.location = `/product/${productId}/edit`;
    },
  },
};
